/* WHO IS LYS — Global JS */
(function () {
  'use strict';

  /* Scroll reveal */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          e.target.setAttribute('data-reveal', 'done');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.reveal, [data-reveal]').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal, [data-reveal]').forEach(function (el) {
      el.classList.add('is-visible');
      el.classList.add('visible');
    });
  }

  /* Cart count update */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var count = d.item_count || 0;
        var bubble = document.getElementById('lysCartCount');
        if (bubble) {
          bubble.textContent = count > 9 ? '9+' : count;
          bubble.classList.toggle('hidden', count === 0);
        }
      }).catch(function () {});
  }
  updateCartCount();
  document.addEventListener('cart:updated', updateCartCount);

})();

/* ===== PROTECTION IMAGES ===== */
(function () {
  // Bloquer clic droit sur les images
  document.addEventListener('contextmenu', function (e) {
    if (e.target.tagName === 'IMG' || e.target.closest('.lys-card__img-wrap, .lys-hero, .lys-col-card, .lys-product__gallery')) {
      e.preventDefault();
      return false;
    }
  });

  // Bloquer le drag des images
  document.addEventListener('dragstart', function (e) {
    if (e.target.tagName === 'IMG') {
      e.preventDefault();
      return false;
    }
  });

  // Bloquer la sélection du texte sur les zones d'images
  document.addEventListener('selectstart', function (e) {
    if (e.target.tagName === 'IMG') {
      e.preventDefault();
      return false;
    }
  });

  // Bloquer les touches clavier de sauvegarde sur les images (Ctrl+S, Ctrl+U, F12 sur img focus)
  document.addEventListener('keydown', function (e) {
    // Ctrl+S / Cmd+S sur une image
    if ((e.ctrlKey || e.metaKey) && e.key === 's') {
      if (document.activeElement && document.activeElement.tagName === 'IMG') {
        e.preventDefault();
      }
    }
  });

  // Désactiver le long-press « enregistrer l'image » sur mobile.
  // 24/07 perf (concile) : ex-boucle par <img> = ~300 addEventListener dont un touchstart NON-passif
  // (fast-path tactile perdu) + un setTimeout vide. Remplacée par du CSS pur (voir lys-critical-css :
  // -webkit-touch-callout:none sur img) — coût main-thread nul, même protection (de toute façon
  // contournable). Le clic droit / drag / sélection restent gérés au niveau document ci-dessus.
})();
